import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown as DropdownLegacy } from '@wix/wix-ui-tpa';
import {
  Dropdown as DropdownCssVars,
  DropdownOptionProps,
} from '@wix/wix-ui-tpa/cssVars';
import { getCurrentTimeSlotId, refreshTimeSlotsAtNextBoundary, getAvailableTimeSlots } from './TimeSlotsDropdown.utils';
import { classes } from './TimeSlotsDropdown.st.css';
import { classes as cssVarsClasses } from './TimeSlotsDropdown.cssVars.st.css';
import s from './TimeSlotsDropdown.scss';
import cx from 'classnames';
import { useTranslation, useExperiments } from '@wix/yoshi-flow-editor';
import { SPECS } from '../../../../../../consts';

export type TimeSlotsDropdownProps = {
  selectedId: string | undefined;
  disabled: boolean;
  isToday: boolean;
  onChange: (option: DropdownOptionProps) => void;
};

export enum TimeSlotsDropdownDataHooks {
  dropdown = 'rise-gift-card-time-picker',
}

export const TimeSlotsDropdown: React.FC<TimeSlotsDropdownProps> = ({
  selectedId,
  disabled,
  isToday,
  onChange,
}) => {
  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const isCssVars = experiments.enabled(
    SPECS.MigrateGiftCardWidgetToCssVars,
  );
  const Dropdown = (
    isCssVars ? DropdownCssVars : DropdownLegacy
  ) as typeof DropdownCssVars;
  const dropdownClassName = isCssVars
    ? cssVarsClasses.timeSlotsDropdown
    : classes.timeSlotsDropdown;
  const [currentTimeSlotId, setCurrentTimeSlotId] = useState(() => getCurrentTimeSlotId());

  useEffect(() => {
    if (!isToday) {
      return;
    }
    return refreshTimeSlotsAtNextBoundary(setCurrentTimeSlotId);
  }, [isToday]);

  const options = useMemo(() => getAvailableTimeSlots(isToday), [isToday, currentTimeSlotId]);

  return (
    <Dropdown
      className={cx(dropdownClassName, s.timeSlotsDropdown)}
      data-hook={TimeSlotsDropdownDataHooks.dropdown}
      placeholder={t('giftCardPage.deliveryTime.expiration.now')}
      options={options}
      selectedId={selectedId}
      disabled={disabled}
      onChange={onChange}
    />
  );
};
